import { NeurodiversitySearcherInfo } from '@lyrahealth-inc/shared-app-logic/src/features/centerOfExcellence/types'

export const SET_NEURODIVERSITY_SEARCHER_INFO = 'SET_NEURODIVERSITY_SEARCHER_INFO'
export const CLEAR_NEURODIVERSITY_SEARCHER_INFO = 'CLEAR_NEURODIVERSITY_SEARCHER_INFO'

export const setNeurodiversitySearcherInfo = (searcherInfo: NeurodiversitySearcherInfo) => {
  return {
    type: SET_NEURODIVERSITY_SEARCHER_INFO,
    value: searcherInfo,
  }
}

export const clearNeurodiversitySearcherInfo = () => {
  return {
    type: CLEAR_NEURODIVERSITY_SEARCHER_INFO,
  }
}
